import { ChangeDetectionStrategy,Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute, Router } from '@angular/router';

import { AdminComponentBase, PageSimpleContentComponent } from 'app/layout/content';
import { LibraryCacheKey } from 'app/shared/graph';

import { LibraryCacheService } from './library-cache.service';
import { LibraryCacheEntryDetailDialogComponent, LibraryCacheEntryDetailDialogData } from './library-cache-entry-detail-dialog.component';

@Component({
    selector: 'admin-library-cache-page',
    imports: [
        PageSimpleContentComponent,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatCardModule,
        MatCheckbox,
        FormsModule
    ],
    templateUrl: './library-cache-page.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './library-cache-page.component.scss'
})
export class LibraryCachePageComponent extends AdminComponentBase implements OnInit, OnDestroy {
    private readonly libraryCacheService = inject(LibraryCacheService);
    private readonly matDialog = inject(MatDialog);
    private readonly route = inject(ActivatedRoute);
    private readonly router = inject(Router);

    searchText = '';
    cacheKeys: LibraryCacheKey[] = [];
    showKey = false;
    deletingKeys = new Set<string>();

    ngOnInit(): void {
        this.subscribeWithGenericLoadingErrorHandling(this.libraryCacheService.getLibraryCacheKeys(this.route.snapshot.queryParams['search'] || ''), (cacheKeys) => {
            this.cacheKeys = cacheKeys;
        });
        this.route.queryParams.subscribe(params => {
            this.searchText = params['search'] || '';
            this.loadCacheKeys();
        });
    }

    ngOnDestroy(): void {
        this.unsubscribeSubscriptions();
    }

    loadCacheKeys() {
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { search: this.searchText || null },
            queryParamsHandling: 'merge'
        }).then();

        this.libraryCacheService.getLibraryCacheKeys(this.searchText).subscribe(keys => {
            this.cacheKeys = keys;
        });

    }

    getCacheEntry(entry: LibraryCacheKey) {
        this.matDialog.open<LibraryCacheEntryDetailDialogComponent, LibraryCacheEntryDetailDialogData, any>(LibraryCacheEntryDetailDialogComponent, {
                data: {
                    cacheEntry: entry
                } as LibraryCacheEntryDetailDialogData
            }
        );
    }

    deleteCacheEntry(key: string) {
        this.deletingKeys.add(key);
        this.libraryCacheService.deleteLibraryCacheEntry(key).subscribe(() => {
            this.deletingKeys.delete(key);
            this.loadCacheKeys();
        });
    }
}
